module.exports = __webpack_public_path__ + "img/aixin.04f45ef3.gif";